import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		"& .block": {
			marginBottom: "50px",

			"&:last-child": {
				marginBottom: 0,
			},
		},
		"& .subblock": {
			marginBottom: "20px",

			"&:last-child": {
				marginBottom: 0,
			},
		},
		"& h2": {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			color: theme.palette.colors.darkSlateBlue2,
			lineHeight: 1,
			letterSpacing: "2px",
			margin: "0 0 30px 0",
			padding: 0,
			textTransform: "uppercase",
			"&.low-margin": {
				marginBottom: "0",
			},
		},
		"& h3": {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			color: theme.palette.colors.darkSlateBlue2,
			lineHeight: 1.25,
			margin: "0 0 6px 0",
			padding: 0,
		},
		"& ul": {
			listStyle: "none",
			margin: 0,
			padding: 0,
		},
		"& li": {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			color: theme.palette.colors.darkSlateBlue2,
			lineHeight: 1.5,
		},
		"& p": {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			color: theme.palette.colors.darkSlateBlue2,
			lineHeight: 1.5,
			marginBottom: "0 0 20px 0",
		},
		"& .icon24": {
			fontSize: "20px",
			color: theme.palette.colors.purplishBlue,
			marginRight: "14px",
		},
		"& .starBlock": {
			display: "flex",
			alignItems: "center",
			marginBottom: "10px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			"& .block": {
				marginBottom: "40px",

				"&:last-child": {
					marginBottom: 0,
				},
			},
			"& .subblock": {
				marginBottom: "15px",

				"&:last-child": {
					marginBottom: 0,
				},
			},
			"& h2": {
				fontSize: "14px",
				margin: "0 0 25px 0",
				"&.low-margin": {
					marginBottom: "0",
				},
			},
			"& h3": {
				fontSize: "14px",
			},
			"& li": {
				fontSize: "14px",
				lineHeight: 1.71,
			},
			"& p": {
				fontSize: "14px",
				lineHeight: 1.71,
				marginBottom: "0 0 15px 0",
			},
			"& .starBlock": {
				marginBottom: "25px",
			},
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			"& .block": {
				marginBottom: "30px",

				"&:last-child": {
					marginBottom: 0,
				},
			},
			"& .subblock": {
				marginBottom: "20px",

				"&:last-child": {
					marginBottom: 0,
				},
			},
			"& h2": {
				fontSize: "14px",
				margin: "0 0 20px 0",
				"&.low-margin": {
					marginBottom: "0",
				},
			},
			"& h3": {
				fontSize: "14px",
			},
			"& li": {
				fontSize: "14px",
				lineHeight: 1.71,
			},
			"& p": {
				fontSize: "14px",
				lineHeight: 1.71,
				marginBottom: "0 0 15px 0",
			},
			"& .starBlock": {
				marginBottom: "15px",
			},
		},
	},
});

class BenefitsHTML extends React.Component {
	render() {
		let classes = this.props.classes;

		if (!this.props.text) {
			return null;
		}

		return (
			<div
				className={classes.root}
				dangerouslySetInnerHTML={{
					__html: this.props.text,
				}}
			/>
		);
	}
}

export default withStyles(styles)(BenefitsHTML);
